import React from "react";

import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import cn from "classnames";

export type SimpleAspectRatioT = (
  | React.HTMLProps<HTMLDivElement>
  | (React.HTMLProps<HTMLButtonElement> & { as: "button" })
) & { atLeast?: "md" | "lg"; allChildren?: boolean };

export const SimpleAspectRatio: React.FC<SimpleAspectRatioT> = props => {
  const { children, as, className, atLeast, allChildren, ...rest } = props;

  const combinedClassName = cn(className, atLeast ? `at-least-${atLeast}` : "always", { "all-children": allChildren });
  const combinedStyles = [cssStyles, styles];

  return as === "button" ? (
    <button
      css={combinedStyles}
      className={combinedClassName}
      {...(rest as React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>)}
    >
      {children}
    </button>
  ) : (
    <div
      css={combinedStyles}
      className={combinedClassName}
      {...(rest as React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>)}
    >
      {children}
    </div>
  );
};

const aspectStyles = css`
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: calc(100% * var(--aspect-ratio));
  }

  &:not(.all-children) {
    > :first-of-type {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  &.all-children {
    > * {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
`;

const cssStyles = css`
  &.always {
    ${aspectStyles};
  }

  &.at-least-md {
    ${CSS_MQ.atLeastMd} {
      ${aspectStyles};
    }
  }

  &.at-least-lg {
    ${CSS_MQ.atLeastLg} {
      ${aspectStyles};
    }
  }
`;

const styles = css`
  position: relative;
  display: block;
`;
